import { FC, useCallback } from 'react';
import { useContextSelector } from 'use-context-selector';
import ShareShoppingListSidePanel from './ShareShoppingListSidePanel';
import { ViewShoppingListsContext } from './ViewShoppingListsContext';

const ShareShoppingListSidePanelContainer: FC = () => {
  const sharingShoppingList = useContextSelector(
    ViewShoppingListsContext,
    (context) => context.sharingShoppingList
  );
  const shareFolderIds = useContextSelector(
    ViewShoppingListsContext,
    (context) => context.shareFolderIds
  );
  const isShareShoppingListPanelOpen = useContextSelector(
    ViewShoppingListsContext,
    (context) => context.isShareShoppingListPanelOpen
  );
  const closeShareShoppingListPanel = useContextSelector(
    ViewShoppingListsContext,
    (context) => context.closeShareShoppingListPanel
  );
  const shareShoppingList = useContextSelector(
    ViewShoppingListsContext,
    (context) => context.shareShoppingList
  );
  const isSharingShoppingList = useContextSelector(
    ViewShoppingListsContext,
    (context) => context.isSharingShoppingList
  );

  const handleShare = useCallback(
    async (payload: {
      folderIds: number[];
      folderAddUsers: number[];
      folderRemoveUsers: number[];
    }) => {
      await shareShoppingList(payload);
      closeShareShoppingListPanel();
    },
    [closeShareShoppingListPanel, shareShoppingList]
  );

  return (
    <ShareShoppingListSidePanel
      isOpen={isShareShoppingListPanelOpen}
      shoppingList={sharingShoppingList}
      folderIds={shareFolderIds}
      isSharing={isSharingShoppingList}
      onClose={closeShareShoppingListPanel}
      onShare={handleShare}
    />
  );
};

export default ShareShoppingListSidePanelContainer;
